import useGlobalContext from "../../../hooks/useGlobalContext.js";
import useUserAgent from "../../../hooks/useUserAgent.js";
import { useHistory } from "react-router-dom";
import { isDirect, isOfMetaOrigin, isOfPPCOrigin } from "../../marketing-url-params.js";
const KEY_MARKET_COUNTRY_CODES = ["us", "fr", "in", "it", "de", "gb", "es", "br"];
export var MDotValueStage;
(function (MDotValueStage) {
    MDotValueStage["USER_ELIGIBLE"] = "userEligible";
    MDotValueStage["USER_SIGNED_IN"] = "userSignedIn";
    MDotValueStage["USER_SIGNED_OUT"] = "userSignedOut";
    MDotValueStage["DIRECT_TRAFFIC"] = "directTraffic";
    MDotValueStage["PAID_TRAFFIC"] = "paidTraffic";
    MDotValueStage["META_TRAFFIC"] = "metaTraffic";
    MDotValueStage["PPC_TRAFFIC"] = "ppcTraffic";
    MDotValueStage["US_TRAFFIC"] = "UsTraffic";
    MDotValueStage["KEY_MARKET_TRAFFIC"] = "keyMarketTraffic";
    MDotValueStage["LAST_MINUTE_BOOKER"] = "lastMinuteBooker";
    MDotValueStage["SHORT_TERM_BOOKER"] = "shortTermBooker";
    MDotValueStage["LANDING_USER"] = "landingUser";
    MDotValueStage["IOS_DEVICE"] = "iosDevice";
    MDotValueStage["ANDROID_DEVICE"] = "androidDevice";
})(MDotValueStage || (MDotValueStage = {}));
export default function useMdotValueTrackDefaultStages() {
    const mdotValueDefaultConditions = useMDotValueDefaultConditions();
    return (stages) => {
        mdotValueDefaultConditions.forEach((value, conditionName) => {
            if (value && conditionName in stages && stages[conditionName]) {
                stages[conditionName]();
            }
        });
    };
}
export function useMDotValueDefaultConditions() {
    const { isMobile } = useUserAgent();
    const history = useHistory();
    const { auth, ipCountry } = useGlobalContext();
    if (!isMobile) {
        return new Map(Object.keys(MDotValueStage).map((stage) => [stage, false]));
    }
    const isSignedIn = auth.isAuthenticatedOnWeb;
    const isKeyMarket = Boolean(ipCountry && KEY_MARKET_COUNTRY_CODES.includes(ipCountry.toLowerCase()));
    const isUsTraffic = Boolean(ipCountry && ipCountry.toLowerCase() === "us");
    const isIOs = Boolean(navigator?.userAgent && /iphone|ipad|ipod|ios/.test(navigator?.userAgent?.toLocaleLowerCase()));
    return new Map([
        [MDotValueStage.USER_SIGNED_IN, isSignedIn],
        [MDotValueStage.USER_SIGNED_OUT, !isSignedIn],
        [MDotValueStage.US_TRAFFIC, isUsTraffic],
        [MDotValueStage.KEY_MARKET_TRAFFIC, isKeyMarket],
        [MDotValueStage.DIRECT_TRAFFIC, isDirect()],
        [MDotValueStage.META_TRAFFIC, isOfMetaOrigin()],
        [MDotValueStage.PPC_TRAFFIC, isOfPPCOrigin()],
        [MDotValueStage.PAID_TRAFFIC, isOfPPCOrigin() || isOfMetaOrigin()],
        [MDotValueStage.LANDING_USER, history.length <= 1],
        [MDotValueStage.IOS_DEVICE, isIOs],
        [MDotValueStage.ANDROID_DEVICE, !isIOs]
    ]);
}
